import { createTheme } from '@mui/material';

export const GrayTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#101246',
            contrastText: '#FFFFFF'
        },
        secondary: {
            main: '#5BB2DD',
            contrastText: '#101246'
        },
        background: {
            default: '#FFFFFF',
            paper: '#F6F8FA'
        },
        text: {
            primary: '#263044',
            secondary: '#657085',
            disabled: '#7F8794'
        },
        divider: '#D7DEE7'
    },
    typography: {
        fontFamily: '"Open Sans", "Roboto", "Arial", sans-serif',
        h1: { fontFamily: '"DIN 2014 NOW", "Open Sans", "Roboto", sans-serif', fontWeight: 700 },
        h2: { fontFamily: '"DIN 2014 NOW", "Open Sans", "Roboto", sans-serif', fontWeight: 700 },
        h3: { fontFamily: '"DIN 2014 NOW", "Open Sans", "Roboto", sans-serif', fontWeight: 700 },
        h4: { fontFamily: '"DIN 2014 NOW", "Open Sans", "Roboto", sans-serif', fontWeight: 700 },
        h5: { fontFamily: '"DIN 2014 NOW", "Open Sans", "Roboto", sans-serif', fontWeight: 700 },
        h6: { fontFamily: '"DIN 2014 NOW", "Open Sans", "Roboto", sans-serif', fontWeight: 700 },
        button: {
            fontWeight: 700,
            textTransform: 'none'
        }
    }
});
